import { useSelector } from 'react-redux';

export default () => useSelector(({ ui }) => ui.options.skillsAssignments);
